import Icon from "@Atom/Icon";
import Styles from "./Styles.module.scss";
import Images from "@Theme/Images";

export default function HeroAdsSeekersLanding() {
  const disabled = false;
  const listTextAdvantage = [
    "10.000+ kandidat aktif",
    "Posting mudah & cepat",
    "Pelamar yang relevan",
    "Kelola kandidat dengan praktis",
  ];
  return (
    <div className={Styles.container}>
      <div className={Styles.content}>
        <div className={Styles.descBox}>
          <div className={Styles.top}>
            <span className={Styles.H1}>
              Temukan Kandidat Terbaik 10X Lebih Cepat
            </span>
            <span className={Styles.desc}>
              Jangkau kandidat terbaik dan temukan talenta yang sesuai dengan
              kebutuhan perusahaan Anda.
            </span>

            <div className={Styles.benefitBox}>
              {listTextAdvantage.map((t, idx) => (
                <div className={Styles.listBenefit} key={idx}>
                  <div className={Styles.iconStarCheck}>
                    <Icon icon={"star-check"} size={24} color={"#FFF"} />
                  </div>
                  <span className={Styles.span}>{t}</span>
                </div>
              ))}
            </div>

            <div className={Styles.buttonBox}>
              <div
                className={`${Styles.buttonPrimary} ${
                  disabled && Styles.disabled
                }`}
                onClick={() => {
                  if (!disabled) {
                    window.open("/contact-us");
                  }
                }}
              >
                Pasang Loker Sekarang
              </div>

              <div
                className={Styles.buttonTransparant}
                onClick={() => {
                  document
                    .getElementById("OurAdvantagesAdsJobSeeker")
                    .scrollIntoView({ behavior: "smooth" });
                }}
              >
                Pelajari Lebih Lanjut
                <Icon icon={"arrow-right"} color={"#FFF"} size={24} />
              </div>
            </div>
          </div>

          <div className={Styles.bottom}>
            <div>
              <img src={Images.GIFTED} alt="" />
              <span className={Styles.bold}>10.000+</span>
              <span className={Styles.span}>Profesional Talents</span>
            </div>

            <div>
              <img src={Images.TAP} alt="" />
              <span className={Styles.bold}>Easy</span>
              <span className={Styles.span}>Easy Platform</span>
            </div>

            <div>
              <img src={Images.CERTIFICATE} alt="" />
              <span className={Styles.bold}>6 Years</span>
              <span className={Styles.span}>Established</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
